import React, { useEffect, useRef, useState } from 'react';


const PopupLarge = ({ onClose, children }) => {
  const modalRef = useRef(null);

  useEffect(() =>{
    document.body.classList.add('overflow-hidden');
    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  },[])

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!onClose) return;

      const isClickInside = modalRef.current?.contains(e.target);

      if (!isClickInside) {
        onClose();
      }
    };

    document.addEventListener('mouseup', handleOutsideClick);
    return () => {
      document.removeEventListener('mouseup', handleOutsideClick);
    };
  }, [onClose]);

  return (
    <div className="block-full h-full fixed top-0 left-0 z-index-max">
      <div className="block-full absolute inset-0" style={{"backdropFilter": "blur(5px)",background:"rgba(0,0,0,0.4)"}}/>

      <div className="flex-column-full justify-center h-full max-w-900 mx-auto py-48 px-16" style={{minHeight: "100%"}}>
        <div className="block-full br-16 bg-surface-2 shadow-lg overflow-hidden" ref={modalRef}
          style={{minHeight:"300px"}}
        >
          <button
            onClick={onClose} 
            className="flex-row-40 h-40 items-center justify-center absolute top-0 right-0
            bg-white fill-accent hover:bg-accent hover:fill-white
            transition-fast shadow-md hover:shadow-lg z-index-10"
            style={{"borderBottomLeftRadius":"16px"}}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z" />
            </svg>
          </button>

          <div className="block-full h-full max-h-full pr-4 pt-40 lg:pt-48 pb-16 md:pb-36 lg:pb-48 text-left overflow-hidden">
            <div className="block-full h-full pl-16 pr-12 md:pl-36 md:pr-32 lg:pl-48 lg:pr-44 scrollbar-sm">
              {children}
            </div>
          </div>
        </div>
      </div>


    </div>
  );
}

const PopupSmall = ({ onClose, children }) => {
  const modalRef = useRef(null);

  useEffect(() =>{
    document.body.classList.add('overflow-hidden');
    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  },[])

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!onClose) return;

      const isClickInside = modalRef.current?.contains(e.target);

      if (!isClickInside) {
        onClose();
      }
    };

    document.addEventListener('mouseup', handleOutsideClick);
    return () => {
      document.removeEventListener('mouseup', handleOutsideClick);
    };
  }, [onClose]);

  return (
    <div className="block-full h-full fixed top-0 left-0 z-index-max">
      <div className="block-full absolute inset-0" style={{"backdropFilter": "blur(5px)",background:"rgba(0,0,0,0.4)"}}/>

      <div className="flex-column-full justify-center h-full max-w-576 mx-auto py-48 px-16" style={{minHeight: "100%"}}>
        <div className="block-full br-16 bg-surface-2 shadow-lg overflow-hidden" ref={modalRef}
          style={{minHeight:"300px"}}
        >
          <button
            onClick={onClose} 
            className="flex-row-40 h-40 items-center justify-center absolute top-12 right-12 md:top-16 md:right-16 lg:top-28 lg:right-28
            bg-white fill-accent hover:bg-accent hover:fill-white
            br-12 transition-fast shadow-md hover:shadow-lg z-index-10"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z" />
            </svg>
          </button>

          <div className="block-full h-full max-h-full pr-4 py-16 md:py-36 lg:py-48 text-left overflow-hidden">
            <div className="block-full h-full bg-dark pl-16 pr-12 md:pl-36 md:pr-32 lg:pl-48 lg:pr-44 scrollbar-sm">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


const PopupPhoto = ({ onClose, children }) => {
  const modalRef = useRef(null);

  useEffect(() =>{
    document.body.classList.add('overflow-hidden');
    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  },[])

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!onClose) return;

      const isClickInside = modalRef.current?.contains(e.target);

      if (!isClickInside) {
        onClose();
      }
    };

    document.addEventListener('mouseup', handleOutsideClick);
    return () => {
      document.removeEventListener('mouseup', handleOutsideClick);
    };
  }, [onClose]);

  return (
    <div className="block-full h-full fixed top-0 left-0 z-index-max">
      <div className="block-full absolute inset-0" style={{"backdropFilter": "blur(5px)",background:"rgba(0,0,0,0.4)"}}/>

      <div className="flex-column-full justify-center h-full max-w-576 mx-auto py-48 px-16" style={{minHeight: "100%"}}>
        <div className="block-full br-16 bg-surface-2 shadow-lg overflow-hidden" ref={modalRef}
          style={{minHeight:"300px"}}
        >
          <button
            onClick={onClose} 
            className="flex-row-32 h-32 md:w-40 md:h-40 items-center justify-center absolute 
            top-0 right-0 md:top-20 md:right-20 lg:top-28 lg:right-28
            bg-white fill-accent hover:bg-accent hover:fill-white
            br-round transition-fast shadow-md hover:shadow-lg z-index-10"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z" />
            </svg>
          </button>

          <div className="block-full h-full max-h-full pr-4 py-16">
            <div className="block-full h-full pl-16 pr-12 md:pl-36 md:pr-32 lg:pl-48 lg:pr-44 md:py-20 lg:py-32 scrollbar-sm">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};






export {
  PopupLarge,
  PopupSmall,
  PopupPhoto,
};
